import { Overlay } from '@angular/cdk/overlay'
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { AlertService } from '@app/alert/service/alert.service'
import { ErrorService } from '@app/error/error.service'
import { ModalService } from '@app/modal/modal.service'
import { RespostaPesquisaRequestModel } from '@shared/models/backend'
import { FormHelperService } from '@widgets/form/services/form-helper.service'
import { PesquisaSatisfacaoService } from '../service/pesquisa-satisfacao.service'

@Component({
  selector: 'app-pesquisa-satisfacao-dialog-component',
  templateUrl: './pesquisa-satisfacao-dialog.component.html',
  styleUrls: ['./pesquisa-satisfacao-dialog.component.scss'],
})
export class PesquisaSatisfacaoDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('pesquisaSatisfacaoComponent') component

  private modal: MatDialogRef<any>
  private submitting: boolean
  private respondido: boolean
  form: FormGroup
  textAreaLabel = `Você tem críticas ou sugestões sobre alguma
 tela ou funcionalidade do SIGRESIDÊNCIAS? Conte para a gente!`

  constructor(
    private formHelper: FormHelperService,
    private modalService: ModalService,
    private pesquisaService: PesquisaSatisfacaoService,
    private alertService: AlertService,
    private errorService: ErrorService,
    private ref: ChangeDetectorRef,
    private overlay: Overlay
  ) {}

  @HostListener('window:resize', ['$event'])
  private getScreenSize(event?) {
    const scrHeight: number = window?.innerHeight
    const scrWidth: number = window?.innerWidth

    return { height: scrHeight, width: scrWidth }
  }

  ngOnInit() {
    this.buildForm()
    this.respondido = false
  }

  ngAfterViewInit(): void {
    this.pesquisaService.getDisponivel().subscribe((_) => !_ || this.openModal())
  }

  private setRespondido(val: boolean) {
    this.respondido = val
  }

  isSubmitting(): boolean {
    return this.submitting
  }

  isRespondido(): boolean {
    return this.respondido
  }

  onSubmit() {
    const avaliacao: RespostaPesquisaRequestModel = this.form.getRawValue()
    if (!this.submitting) {
      this.submitting = true
      const response = this.pesquisaService.save(avaliacao)
      response.subscribe(
        (pesquisaResponse) => {
          this.alertService.showSuccess('Avaliação enviada com sucesso')
          this.setRespondido(true)
        },
        (error) => {
          this.errorService.handleBackendValidationError(error, this.form, this.ref)
          this.submitting = false
        }
      )
    }
  }

  onCancel(): void {
    const avaliacao = ({
      comentario: null,
      grauSatisfacao: null,
    } as unknown) as RespostaPesquisaRequestModel
    const response = this.pesquisaService.save(avaliacao)
    response.subscribe(
      (success) => this.closeModal(),
      (error) => this.closeModal()
    )
  }

  buildForm() {
    this.form = this.formHelper.createForm<RespostaPesquisaRequestModel>(
      {
        grauSatisfacao: undefined,
        comentario: '',
      },
      {
        grauSatisfacao: undefined,
        comentario: undefined,
      }
    )
  }

  openModal(): void {
    let dialogConfig = new MatDialogConfig()
    const width: number = this.getScreenSize()?.width

    dialogConfig = {
      width: '25em',
      maxWidth: '25em',
      position: { bottom: '0', right: width >= 495 ? '10%' : null },
      hasBackdrop: false,
      restoreFocus: false,
      disableClose: true,
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      panelClass: 'no-padding',
    }

    this.modal = this.modalService.openCustomComponentModal(this.component, dialogConfig)
  }

  closeModal(): void {
    this.modal.close()
  }

  get shouldDisableSubmit(): boolean {
    return !this?.form?.controls?.grauSatisfacao?.value || this.isSubmitting()
  }
}
